import React, { useContext, useEffect } from 'react';
import {
	IEditModifierGroupsContext,
	EditModifierGroupsContext,
} from '../../editModifierGroupsState/editModifierGroupsContext';
import EditForm from './components/EditForm/EditForm';
import TranslationsForm from './components/TranslationsForm';
import style from './Forms.module.scss';

const Forms: React.FC = () => {
	const { visibleForm } = useContext<IEditModifierGroupsContext>(EditModifierGroupsContext);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [visibleForm]);

	return (
		<div className={style.container} data-test="Forms">
			<EditForm isVisible={visibleForm === 'mainForm'} />
			<TranslationsForm isVisible={visibleForm === 'translations'} />
		</div>
	);
};

export default Forms;
